// tries to cast a string to JSON object,
// if not, it returns itself
export default str => {
  try {
    return JSON.parse(str);
  } catch (e) {
    return str;
  }
};
